export function jump(appId, path) {
  let url = path
  if (appId && appId.length > 0) {
    url = `weixin://dl/business/?appid=${appId}&path=${path}`
  }
  window.location.href = url
}